export const logoutQuery = `
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      code
    }
  }
`;
